"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.blockSchedulerNode = blockSchedulerNode;
exports.deleteSchedulerNode = deleteSchedulerNode;
exports.enableSchedulerNode = enableSchedulerNode;
exports.fetchSchedulerNodes = fetchSchedulerNodes;
exports.updateSchedulerNodeWeight = updateSchedulerNodeWeight;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function fetchSchedulerNodes(params) {
  return (0, _request.default)({
    url: '/admin/scheduler/node/page',
    method: 'get',
    params: params
  });
}
function blockSchedulerNode(id) {
  return (0, _request.default)({
    url: "/admin/scheduler/node/block/".concat(id),
    method: 'post'
  });
}
function enableSchedulerNode(id) {
  return (0, _request.default)({
    url: "/admin/scheduler/node/enable/".concat(id),
    method: 'post'
  });
}
function deleteSchedulerNode(id) {
  return (0, _request.default)({
    url: "/admin/scheduler/node/".concat(id),
    method: 'delete'
  });
}
function updateSchedulerNodeWeight(id, weight) {
  return (0, _request.default)({
    url: "/admin/scheduler/node/weight/".concat(id),
    method: 'post',
    data: {
      weight: weight
    }
  });
}